import {
	useEffect,useState
} from 'react';

function useColor(str) {
	const [state, setState] = useState({
		color: '',
		invertedColor: '',
	});

	function hashCode(str) {
		var hash = 0;
		for (var i = 0; i < str.length; i++) {
			if (str.length < 3) {
				// initialize hash with larger value to get more randomness
				hash += str.charCodeAt(i) * 31 * (str.charCodeAt(i) << 5)
			}
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		return hash;
	}

	function intToRGB(i) {
		var c = (i & 0x00FFFFFF).toString(16).toUpperCase();
		return '00000'.substring(0,
			6 - c.length) + c;
	}

	// Inverting color (for text on top of background color)
	function padZero(str, len) {
		len = len || 2;
		var zeros = new Array(len).join('0');
		return (zeros + str).slice(-len);
	}

	function invertColor(hex, disable_bw) {
		// https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
		if (hex.indexOf('#') === 0) {
			hex = hex.slice(1);
		}
		// convert 3-digit hex to 6-digits.
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}
		if (hex.length !== 6) {
			throw new Error('Invalid HEX color.');
		}
		var r = parseInt(hex.slice(0,
				2),
			16),
			g = parseInt(hex.slice(2,
				4),
			16),
			b = parseInt(hex.slice(4,
				6),
			16);
		if (!disable_bw) {
			// Default to black/white as inverted (text) color
			// http://stackoverflow.com/a/3943023/112731
			return (r * 0.299 + g * 0.587 + b * 0.114) > 186
				? '#000000'
				: '#FFFFFF';
		}
		// invert color components
		r = (255 - r).toString(16);
		g = (255 - g).toString(16);
		b = (255 - b).toString(16);
		// pad each with zeros and return
		return padZero(r) + padZero(g) + padZero(b);
	}

	function generateColor(id) {
		// hash string and generate hex color
		return `#${intToRGB(hashCode(String(id)))}`
	}

	useEffect(() => {
		const color = generateColor(str);
		const invertedColor = invertColor(color);
		setState({
			invertedColor,
			color,
		});
	},
	[]);

	return state;
}
export default useColor;
